import React from "react";
import "./App.css";
import Footer from "./Footer";
import Results from "./Results";
import Menu from "./Menu";


export default function App() {

   return (
     <div className="App">
       <div className="weather-app-container">
         <div className="row">
           <div className="col-7">
             <div className="container bit-card">
               <Results defaultCity="Singapore" />
             </div>
           </div>
           <div className="col-4">
             <div className="container vertical-menu-card">
               <Menu />
             </div>
             <div className="container message-box">
               <h5>Welcome to World Weather!</h5>
               <p>What do you think today will be like?</p>
               <div className="down-arrow"></div>
             </div>
             <Footer />
           </div>
         </div>
       </div>
     </div>
   );
} 

